import { BookingState } from '../modules/booking-state/BookingState';

export function resetApplicationContext(): BookingState {
  return {
    selectedDealer: undefined,
    customerDropOffRequested: undefined,
    selectedSlot: undefined,
    tcosEstimation: undefined,
    serviceRequest: undefined,
    customerContact: undefined,
    customerCollectionRequested: undefined,
    createdBooking: undefined,
    registrationNumber: undefined,
    vehicleServiceHistory: undefined,
    nationalIdNumber: undefined,
    passportNumber: undefined,
    vehicleDetails: undefined,
  };
}
